import { autocompleteHistoryLSKey } from '../../../configuration/Configuration.js';

export default (suggestions) => {
  localStorage.setItem(autocompleteHistoryLSKey, JSON.stringify(suggestions ?? []));
};
